import { getContentType, getLanguae, getSearchCountry, getCmsDomain } from 'common/util'
import request, { ResponseData } from './request'
import { has, isArray, omit, pick } from 'lodash'

const Omits = ['createdAt', 'locale', 'pn', 'publishedAt', 'updatedAt', 'tabs', 'color']

export enum IGuideComponentType {
  Banner = 'global.tutorial-bg-banner',
  Logo = 'global.tutorial-logo',
}

export enum IGuideFeatureLayout {
  Vertical = 'vertical',
  Grid = 'grid',
}

export interface IGuideBanner {
  id: number
  banner?: Array<{ url: string; name: string; height: number; width: number }>
  __component: string
  listing: Array<{
    icon?: string
    id: number
    title: string
    url: string
  }>
  layout?: string
}

export interface IGuideLogo {
  id: number
  logo?: Array<{ url: string; name: string }>
  __component: string
  listing: Array<{
    icon?: string
    id: number
    title: string
    url: string
  }>
  layout?: string
  background?: string
}

export interface IGuide {
  id: string
  title: string
  subtitle: string
  pn?: string
  countries?: string
  color?: string
  tabs: Array<IGuideLogo | IGuideBanner>
}

interface GetGuideResponse {
  data: {
    data: {
      id: number
      attributes: {
        title: string
        subtitle: string
        // banner: {
        //   data: Array<{
        //     id: number
        //     attributes: {
        //       url: string
        //       name: string
        //     }
        //   }>
        // }
        // logo: {
        //   data: Array<{
        //     id: number
        //     attributes: {
        //       url: string
        //       name: string
        //     }
        //   }>
        // }
        // background: string
        color: string
        tabs: Array<
          {
            __component: string
            id: number
            layout: string
            listing: any
          } & { [k: string]: any }
        >
      }
    }
  }
}

// 获取五码页面数据
const getQuickStart = async (params: { pn?: string; id?: string }) => {
  const content_type = await getContentType()
  const lang = getLanguae()
  const country = getSearchCountry()

  const link = `${await getCmsDomain()}/v1/cms_service/cms/get_quick_start`

  const _params = { ...params, content_type: content_type.quick, lang, country }
  return request<ResponseData<GetGuideResponse>>(
    link,
    {
      method: 'POST',
      data: _params,
    },
    {
      ignoreAuthToken: true,
    }
  )
    .then(res => {
      if (res.code === 0 && has(res, 'data.data.data.attributes')) {
        if (!params.id) {
          params.id = String(res.data.data.data.id) ?? ''
        }
        return res.data.data.data.attributes
      } else {
        return Promise.reject(null)
      }
    })
    .then(res => {
      let { tabs: _tabs, color, subtitle, title } = res

      // tabs 处理
      const tabslist = _tabs.map((item: any) => {
        // banner
        if (item.__component === IGuideComponentType.Banner) {
          // banner 处理
          item.banner =
            item.banner.data && !item.banner.data.length
              ? [pick(item.banner.data.attributes, ['url', 'name', 'height','width'])]
              : item.banner.data?.map((item: { attributes: any }) =>
                  pick(item.attributes, ['url', 'name', 'height','width'])
                ) || []

          if (item.listing && isArray(item.listing)) {
            item.listing = item.listing.map((feature: any) => {
              feature.icon = feature.icon.data?.attributes.url
              return feature
            })
          }
        }

        // logo
        if (item.__component === IGuideComponentType.Logo) {
          // Logo 处理
          item.logo =
            item.logo.data && !item.logo.data.length
              ? [pick(item.logo.data.attributes, ['url', 'name'])]
              : item.logo.data?.map((item: { attributes: any }) => pick(item.attributes, ['url', 'name'])) || []

          if (item.listing && isArray(item.listing)) {
            item.listing = item.listing.map((feature: any) => {
              feature.icon = feature.icon.data?.attributes.url
              return feature
            })
          }
        }

        return item
      })
      // 只取第一个tab
      const tabs = []
      tabs.push(tabslist[0])
      return { id: params.id, tabs, title, subtitle, color, ...omit(res, Omits) } as IGuide
    })
}

export default getQuickStart
